import { AdminSearch, SettingsSection } from "../AdminWorkspace";
import React, { useEffect, useState } from "react";
import clsx from "clsx";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import useSettings from "../../hooks/useSettings";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";

import { TextField, Switch } from "@material-ui/core";
import {
  ChatBubbleOutline,
  ContactMailOutlined,
  MemoryOutlined,
  PaymentOutlined,
  SecurityOutlined,
  TuneOutlined,
} from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import AiUsageCard from "../AiUsageCard";
import { usePanelStyles, SettingRow } from "../FormFields/panel";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    optionsRoot: { width: "100%", minWidth: 0 },
    hint: { margin: "-2px 0 16px", fontSize: 12.5, lineHeight: 1.5, color: t.textSecondary },
    // chave liga/desliga: no celular o texto e a chave continuam lado a lado
    toggleRow: {
      [theme.breakpoints.down("xs")]: {
        flexDirection: "row",
        alignItems: "center",
        gap: 14,
        "& > div:last-child": { justifyContent: "flex-end" },
      },
    },
    // select/campo dentro de uma linha de opção; ancora o aviso "Atualizando…"
    control: { position: "relative", width: "100%", minWidth: 0 },
    // "Atualizando…" discreto, sem empurrar o layout enquanto a opção grava
    updating: { flex: "none", fontSize: 12, lineHeight: 1.4, color: t.textMuted, whiteSpace: "nowrap" },
    updatingBelow: { position: "absolute", top: "calc(100% + 1px)", right: 0, fontSize: 11 },
    updatingCorner: { position: "absolute", top: 0, right: 0 },
    // campos longos (mensagens, credenciais) abaixo da lista de opções da seção
    fields: { paddingTop: 14, paddingBottom: 4 },
    fieldsAfterList: { marginTop: 2, paddingTop: 16, borderTop: `1px solid ${t.lineRow}` },
    field: { position: "relative", minWidth: 0 },
    extra: { marginTop: 14 },
  };
});

const Updating = ({ classes, show, placement, text }) =>
  show ? (
    <span className={clsx(classes.updating, placement && classes[placement])} role="status">
      {text || i18n.t("settings.settings.options.updating")}
    </span>
  ) : null;

const ToggleSetting = ({
  classes,
  label,
  description,
  value,
  onChange,
  loading,
  enabledValue = "enabled",
  disabledValue = "disabled",
}) => (
  <SettingRow label={label} description={description} className={classes.toggleRow}>
    <Updating classes={classes} show={loading} />
    <Switch
      color="primary"
      checked={value === enabledValue}
      disabled={loading}
      onChange={(event) => onChange(event.target.checked ? enabledValue : disabledValue)}
      inputProps={{ "aria-label": label }}
    />
  </SettingRow>
);

export default function Options(props) {
  const [search, setSearch] = useState("");
  const { oldSettings, settings, scheduleTypeChanged, user } = props;

  const classes = useStyles();
  const p = usePanelStyles();
  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [chatBotType, setChatBotType] = useState("text");

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [userRatingMode, setUserRatingMode] = useState("text");
  const [typingIndicator, setTypingIndicator] = useState("enabled");
  const [loadingTypingIndicator, setLoadingTypingIndicator] = useState(false);
  const [loadingUserRatingMode, setLoadingUserRatingMode] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);

  const [userCreation, setUserCreation] = useState("disabled");
  const [loadingUserCreation, setLoadingUserCreation] = useState(false);

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("enabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);

  const [UserRandom, setUserRandom] = useState("enabled");
  const [loadingUserRandom, setLoadingUserRandom] = useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("enabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);

  const [AcceptCallWhatsapp, setAcceptCallWhatsapp] = useState("enabled");
  const [loadingAcceptCallWhatsapp, setLoadingAcceptCallWhatsapp] = useState(false);

  const [sendSignMessage, setSendSignMessage] = useState("enabled");
  const [loadingSendSignMessage, setLoadingSendSignMessage] = useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("enabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  const [sendQueuePosition, setSendQueuePosition] = useState("enabled");
  const [loadingSendQueuePosition, setLoadingSendQueuePosition] = useState(false);

  const [sendFarewellWaitingTicket, setSendFarewellWaitingTicket] = useState("enabled");
  const [loadingSendFarewellWaitingTicket, setLoadingSendFarewellWaitingTicket] = useState(false);

  const [acceptAudioMessageContact, setAcceptAudioMessageContact] = useState("enabled");
  const [loadingAcceptAudioMessageContact, setLoadingAcceptAudioMessageContact] = useState(false);

  //PAYMENT METHODS
  const [eficlientidType, setEfiClientidType] = useState('');
  const [loadingEfiClientidType, setLoadingEfiClientidType] = useState(false);

  const [eficlientsecretType, setEfiClientsecretType] = useState('');
  const [loadingEfiClientsecretType, setLoadingEfiClientsecretType] =
    useState(false);

  const [efichavepixType, setEfiChavepixType] = useState('');
  const [loadingEfiChavepixType, setLoadingEfiChavepixType] = useState(false);

  const [mpaccesstokenType, setmpaccesstokenType] = useState('');
  const [loadingmpaccesstokenType, setLoadingmpaccesstokenType] =
    useState(false);

  const [stripeprivatekeyType, setstripeprivatekeyType] = useState('');
  const [loadingstripeprivatekeyType, setLoadingstripeprivatekeyType] =
    useState(false);

  const [asaastokenType, setasaastokenType] = useState('');
  const [loadingasaastokenType, setLoadingasaastokenType] = useState(false);

  //OPENAI API KEY TRANSCRIÇÃO DE ÁUDIO
  const [openaitokenType, setopenaitokenType] = useState('');
  const [loadingopenaitokenType, setLoadingopenaitokenType] = useState(false);

  //LGPD
  const [enableLGPD, setEnableLGPD] = useState("disabled");
  const [loadingEnableLGPD, setLoadingEnableLGPD] = useState(false);

  const [lgpdMessage, setLGPDMessage] = useState("");
  const [loadinglgpdMessage, setLoadingLGPDMessage] = useState(false);

  const [lgpdLink, setLGPDLink] = useState("");
  const [loadingLGPDLink, setLoadingLGPDLink] = useState(false);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState("disabled");
  const [loadingLGPDDeleteMessage, setLoadingLGPDDeleteMessage] = useState(false);

  //LIMITAR DOWNLOAD
  // const [downloadLimit, setdownloadLimit] = useState("64");
  // const [loadingDownloadLimit, setLoadingdownloadLimit] = useState(false);

  const [lgpdConsent, setLGPDConsent] = useState("disabled");
  const [loadingLGPDConsent, setLoadingLGPDConsent] = useState(false);

  const [lgpdHideNumber, setLGPDHideNumber] = useState("disabled");
  const [loadingLGPDHideNumber, setLoadingLGPDHideNumber] = useState(false);

  // Tag obrigatoria
  const [requiredTag, setRequiredTag] = useState("enabled")
  const [loadingRequiredTag, setLoadingRequiredTag] = useState(false)

  // Fechar ticket ao transferir para outro setor
  const [closeTicketOnTransfer, setCloseTicketOnTransfer] = useState(false)
  const [loadingCloseTicketOnTransfer, setLoadingCloseTicketOnTransfer] = useState(false)

  // Usar carteira de clientes
  const [directTicketsToWallets, setDirectTicketsToWallets] = useState(false)
  const [loadingDirectTicketsToWallets, setLoadingDirectTicketsToWallets] = useState(false)

  // Sigla para inserir no copiar contatos
  const [copyContactPrefix, setCopyContactPrefix] = useState("");
const [loadingCopyContactPrefix, setLoadingCopyContactPrefix] = useState(false);

  //MENSAGENS CUSTOMIZADAS
  const [transferMessage, setTransferMessage] = useState("");
  const [loadingTransferMessage, setLoadingTransferMessage] = useState(false);

  const [greetingAcceptedMessage, setGreetingAcceptedMessage] = useState("");
  const [loadingGreetingAcceptedMessage, setLoadingGreetingAcceptedMessage] = useState(false);

  const [AcceptCallWhatsappMessage, setAcceptCallWhatsappMessage] = useState("");
  const [loadingAcceptCallWhatsappMessage, setLoadingAcceptCallWhatsappMessage] = useState(false);

  const [sendQueuePositionMessage, setSendQueuePositionMessage] = useState("");
  const [loadingSendQueuePositionMessage, setLoadingSendQueuePositionMessage] = useState(false);

  const [showNotificationPending, setShowNotificationPending] = useState(false);
  const [loadingShowNotificationPending, setLoadingShowNotificationPending] = useState(false);

  const { update: updateUserCreation, getAll } = useSettings();

  // const { update: updatedownloadLimit } = useSettings();

  const { update: updateeficlientid } = useSettings();
  const { update: updateeficlientsecret } = useSettings();
  const { update: updateefichavepix } = useSettings();
  const { update: updatempaccesstoken } = useSettings();
  const { update: updatestripeprivatekey } = useSettings();
  const { update: updateasaastoken } = useSettings();
  const { update: updateCopilotSetting } = useSettings();

  // Copiloto (IA)
  const [copilotEnabled, setCopilotEnabled] = useState("disabled");
  const [loadingCopilotEnabled, setLoadingCopilotEnabled] = useState(false);
  const [copilotHasKey, setCopilotHasKey] = useState(false);
  const [copilotApiKey, setCopilotApiKey] = useState("");
  const [loadingCopilotApiKey, setLoadingCopilotApiKey] = useState(false);
  const [copilotModel, setCopilotModel] = useState("gpt-4o-mini");
  const [loadingCopilotModel, setLoadingCopilotModel] = useState(false);
  const [copilotSummarizeOnTransfer, setCopilotSummarizeOnTransfer] = useState("enabled");
  const [loadingCopilotSummarizeOnTransfer, setLoadingCopilotSummarizeOnTransfer] = useState(false);

  const { update } = useCompanySettings();

  const isSuper = () => {
    return user.super;
  };


  useEffect(() => {

    if (Array.isArray(oldSettings) && oldSettings.length) {

      const userPar = oldSettings.find((s) => s.key === "userCreation");

      if (userPar) {
        setUserCreation(userPar.value);
      }

      // const downloadLimit = oldSettings.find((s) => s.key === "downloadLimit");

      // if (downloadLimit) {
      //  setdownloadLimit(downloadLimit.value);
      // }

      const copyContactPrefix = oldSettings.find((s) => s.key === 'copyContactPrefix');
      if (copyContactPrefix) {
        setCopyContactPrefix(copyContactPrefix.value);
      }

      const eficlientidType = oldSettings.find((s) => s.key === 'eficlientid');
      if (eficlientidType) {
        setEfiClientidType(eficlientidType.value);
      }

      const eficlientsecretType = oldSettings.find((s) => s.key === 'eficlientsecret');
      if (eficlientsecretType) {
        setEfiClientsecretType(eficlientsecretType.value);
      }

      const efichavepixType = oldSettings.find((s) => s.key === 'efichavepix');
      if (efichavepixType) {
        setEfiChavepixType(efichavepixType.value);
      }

      const mpaccesstokenType = oldSettings.find((s) => s.key === 'mpaccesstoken');
      if (mpaccesstokenType) {
        setmpaccesstokenType(mpaccesstokenType.value);
      }

      const asaastokenType = oldSettings.find((s) => s.key === 'asaastoken');
      if (asaastokenType) {
        setasaastokenType(asaastokenType.value);
      }

      const copilotEnabledSetting = oldSettings.find((s) => s.key === "copilotEnabled");
      if (copilotEnabledSetting) {
        setCopilotEnabled(copilotEnabledSetting.value === "enabled" ? "enabled" : "disabled");
      }
      const copilotApiKeySetting = oldSettings.find((s) => s.key === "copilotApiKey");
      // a chave nunca volta em claro: o backend devolve "***" quando existe
      setCopilotHasKey(!!(copilotApiKeySetting && copilotApiKeySetting.value));
      setCopilotApiKey("");
      const copilotModelSetting = oldSettings.find((s) => s.key === "copilotModel");
      if (copilotModelSetting && copilotModelSetting.value) {
        setCopilotModel(copilotModelSetting.value);
      }
      const copilotSummarizeSetting = oldSettings.find((s) => s.key === "copilotSummarizeOnTransfer");
      if (copilotSummarizeSetting) {
        setCopilotSummarizeOnTransfer(copilotSummarizeSetting.value === "disabled" ? "disabled" : "enabled");
      }

    }
  }, [oldSettings])


  useEffect(() => {
    for (const [key, value] of Object.entries(settings)) {
      if (key === "userRating") setUserRating(value);
      if (key === "userRatingMode") setUserRatingMode(value);
      if (key === "typingIndicator") setTypingIndicator(value || "enabled");
      if (key === "scheduleType") setScheduleType(value);
      if (key === "chatBotType") setChatBotType(value);
      if (key === "acceptCallWhatsapp") setAcceptCallWhatsapp(value);
      if (key === "userRandom") setUserRandom(value);
      if (key === "sendGreetingMessageOneQueues") setSendGreetingMessageOneQueues(value);
      if (key === "sendSignMessage") setSendSignMessage(value);
      if (key === "sendFarewellWaitingTicket") setSendFarewellWaitingTicket(value);
      if (key === "sendGreetingAccepted") setSendGreetingAccepted(value);
      if (key === "sendQueuePosition") setSendQueuePosition(value);
      if (key === "acceptAudioMessageContact") setAcceptAudioMessageContact(value);
      if (key === "enableLGPD") setEnableLGPD(value);
      if (key === "requiredTag") setRequiredTag(value);
      if (key === "lgpdDeleteMessage") setLGPDDeleteMessage(value)
      if (key === "lgpdHideNumber") setLGPDHideNumber(value);
      if (key === "lgpdConsent") setLGPDConsent(value);
      if (key === "lgpdMessage") setLGPDMessage(value);
      if (key === "sendMsgTransfTicket") setSettingsTransfTicket(value);
      if (key === "lgpdLink") setLGPDLink(value);
      if (key === "DirectTicketsToWallets") setDirectTicketsToWallets(value);
      if (key === "closeTicketOnTransfer") setCloseTicketOnTransfer(value);
      if (key === "transferMessage") setTransferMessage(value);
      if (key === "greetingAcceptedMessage") setGreetingAcceptedMessage(value);
      if (key === "AcceptCallWhatsappMessage") setAcceptCallWhatsappMessage(value);
      if (key === "sendQueuePositionMessage") setSendQueuePositionMessage(value);
      if (key === "showNotificationPending") setShowNotificationPending(value);
      if (key === "copyContactPrefix") setCopyContactPrefix(value);
    }
  }, [settings]);

  async function handleChangeUserCreation(value) {
    setUserCreation(value);
    setLoadingUserCreation(true);
    await updateUserCreation({
      key: "userCreation",
      value,
    });
    setLoadingUserCreation(false);
  }

  // async function handleDownloadLimit(value) {
  //   setdownloadLimit(value);
  //   setLoadingdownloadLimit(true);
  //   await updatedownloadLimit({
  //     key: "downloadLimit",
  //     value,
  //   });
  //   setLoadingdownloadLimit(false);
  // }

  async function handleChangeEfiClientid(value) {
    setEfiClientidType(value);
    setLoadingEfiClientidType(true);
    await updateeficlientid({
      key: 'eficlientid',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingEfiClientidType(false);
  }

async function handleCopyContactPrefix(value) {
  setCopyContactPrefix(value);
  setLoadingCopyContactPrefix(true);
  await update({
    column: "copyContactPrefix",
    data: value
  });
  setLoadingCopyContactPrefix(false);
}

  async function handleChangeEfiClientsecret(value) {
    setEfiClientsecretType(value);
    setLoadingEfiClientsecretType(true);
    await updateeficlientsecret({
      key: 'eficlientsecret',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingEfiClientsecretType(false);
  }

  async function handleChangeEfiChavepix(value) {
    setEfiChavepixType(value);
    setLoadingEfiChavepixType(true);
    await updateefichavepix({
      key: 'efichavepix',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingEfiChavepixType(false);
  }

  async function handleChangempaccesstoken(value) {
    setmpaccesstokenType(value);
    setLoadingmpaccesstokenType(true);
    await updatempaccesstoken({
      key: 'mpaccesstoken',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingmpaccesstokenType(false);
  }

  async function handleChangestripeprivatekey(value) {
    setstripeprivatekeyType(value);
    setLoadingstripeprivatekeyType(true);
    await updatestripeprivatekey({
      key: 'stripeprivatekey',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingstripeprivatekeyType(false);
  }

  async function handleChangeasaastoken(value) {
    setasaastokenType(value);
    setLoadingasaastokenType(true);
    await updateasaastoken({
      key: 'asaastoken',
      value,
    });
    toast.success('Operação atualizada com sucesso.');
    setLoadingasaastokenType(false);
  }

  async function handleChangeCopilotEnabled(checked) {
    const value = checked ? "enabled" : "disabled";
    setCopilotEnabled(value);
    setLoadingCopilotEnabled(true);
    try {
      await updateCopilotSetting({ key: "copilotEnabled", value });
      toast.success(i18n.t("copilot.settings.saved"));
    } catch (err) {
      toast.error(i18n.t("copilot.settings.saveError"));
    } finally {
      setLoadingCopilotEnabled(false);
    }
  }

  async function handleSaveCopilotApiKey() {
    const value = (copilotApiKey || "").trim();
    if (!value || value === "***") return;
    setLoadingCopilotApiKey(true);
    try {
      await updateCopilotSetting({ key: "copilotApiKey", value });
      setCopilotHasKey(true);
      setCopilotApiKey("");
      toast.success(i18n.t("copilot.settings.keySaved"));
    } catch (err) {
      toast.error(i18n.t("copilot.settings.saveError"));
    } finally {
      setLoadingCopilotApiKey(false);
    }
  }

  async function handleChangeCopilotModel(value) {
    setCopilotModel(value);
    setLoadingCopilotModel(true);
    try {
      await updateCopilotSetting({ key: "copilotModel", value });
      toast.success(i18n.t("copilot.settings.saved"));
    } catch (err) {
      toast.error(i18n.t("copilot.settings.saveError"));
    } finally {
      setLoadingCopilotModel(false);
    }
  }

  async function handleChangeCopilotSummarizeOnTransfer(checked) {
    const value = checked ? "enabled" : "disabled";
    setCopilotSummarizeOnTransfer(value);
    setLoadingCopilotSummarizeOnTransfer(true);
    try {
      await updateCopilotSetting({ key: "copilotSummarizeOnTransfer", value });
      toast.success(i18n.t("copilot.settings.saved"));
    } catch (err) {
      toast.error(i18n.t("copilot.settings.saveError"));
    } finally {
      setLoadingCopilotSummarizeOnTransfer(false);
    }
  }

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      column: "userRating",
      data: value
    });
    setLoadingUserRating(false);
  }

  async function handleChangeUserRatingMode(value) {
    setUserRatingMode(value);
    setLoadingUserRatingMode(true);
    await update({
      column: "userRatingMode",
      data: value
    });
    setLoadingUserRatingMode(false);
  }

  async function handleChangeTypingIndicator(value) {
    setTypingIndicator(value);
    setLoadingTypingIndicator(true);
    await update({
      column: "typingIndicator",
      data: value
    });
    setLoadingTypingIndicator(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      column: "scheduleType",
      data: value
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === "function") {
      scheduleTypeChanged(value);
    }
  }

  async function handleCopyContactPrefix(value) {
    setCopyContactPrefix(value);
    setLoadingCopyContactPrefix(true);
    await update({
      column: "copyContactPrefix",
      data: value
    });
    setLoadingCopyContactPrefix(false);
  }

  async function handleChatBotType(value) {
    setChatBotType(value);
    await update({
      column: "chatBotType",
      data: value
    });
    if (typeof scheduleTypeChanged === "function") {
      setChatBotType(value);
    }
  }

  async function handleLGPDMessage(value) {
    setLGPDMessage(value);
    setLoadingLGPDMessage(true);
    await update({
      column: "lgpdMessage",
      data: value
    });
    setLoadingLGPDMessage(false);
  }

  async function handletransferMessage(value) {
    setTransferMessage(value);
    setLoadingTransferMessage(true);
    await update({
      column: "transferMessage",
      data: value
    });
    setLoadingTransferMessage(false);
  }

  async function handleGreetingAcceptedMessage(value) {
    setGreetingAcceptedMessage(value);
    setLoadingGreetingAcceptedMessage(true);
    await update({
      column: "greetingAcceptedMessage",
      data: value
    });
    setLoadingGreetingAcceptedMessage(false);
  }

  async function handleAcceptCallWhatsappMessage(value) {
    setAcceptCallWhatsappMessage(value);
    setLoadingAcceptCallWhatsappMessage(true);
    await update({
      column: "AcceptCallWhatsappMessage",
      data: value
    });
    setLoadingAcceptCallWhatsappMessage(false);
  }

  async function handlesendQueuePositionMessage(value) {
    setSendQueuePositionMessage(value);
    setLoadingSendQueuePositionMessage(true);
    await update({
      column: "sendQueuePositionMessage",
      data: value
    });
    setLoadingSendQueuePositionMessage(false);
  }

  async function handleShowNotificationPending(value) {
    setShowNotificationPending(value);
    setLoadingShowNotificationPending(true);
    await update({
      column: "showNotificationPending",
      data: value
    });
    setLoadingShowNotificationPending(false);
  }

  async function handleLGPDLink(value) {
    setLGPDLink(value);
    setLoadingLGPDLink(true);
    await update({
      column: "lgpdLink",
      data: value
    });
    setLoadingLGPDLink(false);
  }

  async function handleLGPDDeleteMessage(value) {
    setLGPDDeleteMessage(value);
    setLoadingLGPDDeleteMessage(true);
    await update({
      column: "lgpdDeleteMessage",
      data: value
    });
    setLoadingLGPDDeleteMessage(false);
  }

  async function handleLGPDConsent(value) {
    setLGPDConsent(value);
    setLoadingLGPDConsent(true);
    await update({
      column: "lgpdConsent",
      data: value
    });
    setLoadingLGPDConsent(false);
  }

  async function handleLGPDHideNumber(value) {
    setLGPDHideNumber(value);
    setLoadingLGPDHideNumber(true);
    await update({
      column: "lgpdHideNumber",
      data: value
    });
    setLoadingLGPDHideNumber(false);
  }

  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      column: "sendGreetingAccepted",
      data: value
    });
    setLoadingSendGreetingAccepted(false);
  }

  async function handleUserRandom(value) {
    setUserRandom(value);
    setLoadingUserRandom(true);
    await update({
      column: "userRandom",
      data: value
    });
    setLoadingUserRandom(false);
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      column: "sendMsgTransfTicket",
      data: value
    });
    setLoadingSettingsTransfTicket(false);
  }

  async function handleAcceptCallWhatsapp(value) {
    setAcceptCallWhatsapp(value);
    setLoadingAcceptCallWhatsapp(true);
    await update({
      column: "acceptCallWhatsapp",
      data: value
    });
    setLoadingAcceptCallWhatsapp(false);
  }

  async function handleSendSignMessage(value) {
    setSendSignMessage(value);
    setLoadingSendSignMessage(true);
    await update({
      column: "sendSignMessage",
      data: value
    });
    localStorage.setItem("sendSignMessage", value === "enabled" ? true : false); //atualiza localstorage para sessão
    setLoadingSendSignMessage(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      column: "sendGreetingMessageOneQueues",
      data: value
    });
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleSendQueuePosition(value) {
    setSendQueuePosition(value);
    setLoadingSendQueuePosition(true);
    await update({
      column: "sendQueuePosition",
      data: value
    });
    setLoadingSendQueuePosition(false);
  }

  async function handleSendFarewellWaitingTicket(value) {
    setSendFarewellWaitingTicket(value);
    setLoadingSendFarewellWaitingTicket(true);
    await update({
      column: "sendFarewellWaitingTicket",
      data: value
    });
    setLoadingSendFarewellWaitingTicket(false);
  }

  async function handleAcceptAudioMessageContact(value) {
    setAcceptAudioMessageContact(value);
    setLoadingAcceptAudioMessageContact(true);
    await update({
      column: "acceptAudioMessageContact",
      data: value
    });
    setLoadingAcceptAudioMessageContact(false);
  }

  async function handleEnableLGPD(value) {
    setEnableLGPD(value);
    setLoadingEnableLGPD(true);
    await update({
      column: "enableLGPD",
      data: value
    });
    setLoadingEnableLGPD(false);
  }

  async function handleRequiredTag(value) {
    setRequiredTag(value);
    setLoadingRequiredTag(true);
    await update({
      column: "requiredTag",
      data: value,
    });
    setLoadingRequiredTag(false);
  }

  async function handleCloseTicketOnTransfer(value) {
    setCloseTicketOnTransfer(value);
    setLoadingCloseTicketOnTransfer(true);
    await update({
      column: "closeTicketOnTransfer",
      data: value,
    });
    setLoadingCloseTicketOnTransfer(false);
  }

  async function handleDirectTicketsToWallets(value) {
    setDirectTicketsToWallets(value);
    setLoadingDirectTicketsToWallets(true);
    await update({
      column: "DirectTicketsToWallets",
      data: value,
    });
    setLoadingDirectTicketsToWallets(false);
  }

  return (
    <div className={classes.optionsRoot}>
      <AdminSearch value={search} onChange={setSearch} placeholder="Buscar configuração ou integração…" />
      <p className={classes.hint}>Abra um módulo para ajustar suas preferências. Cada opção é salva automaticamente ao ser alterada.</p>

      <SettingsSection id="attendance" title="Atendimento e distribuição" description="Recepção, avaliação e encaminhamento das conversas." icon={<ChatBubbleOutline />} query={search} defaultOpen={true}>
        {isSuper() && (
          <ToggleSetting
            classes={classes}
            label={i18n.t("settings.settings.options.creationCompanyUser")}
            description="Permite a criação de novas empresas e usuários."
            value={userCreation}
            onChange={handleChangeUserCreation}
            loading={loadingUserCreation}
          />
        )}

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.evaluations")}
          description="Solicita uma avaliação do cliente ao concluir o atendimento."
          value={userRating}
          onChange={handleChangeUserRating}
          loading={loadingUserRating}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.ratingButtons")}
          description={i18n.t("settings.settings.options.ratingButtonsHelp")}
          value={userRatingMode}
          onChange={handleChangeUserRatingMode}
          loading={loadingUserRatingMode}
          enabledValue="buttons"
          disabledValue="text"
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.typingIndicator")}
          description={i18n.t("settings.settings.options.typingIndicatorHelp")}
          value={typingIndicator}
          onChange={handleChangeTypingIndicator}
          loading={loadingTypingIndicator}
        />

        {/* AGENDAMENTO DE EXPEDIENTE */}
        <SettingRow
          wide
          label={i18n.t("settings.settings.options.officeScheduling")}
          description="Define se o horário de atendimento é controlado por fila, por empresa ou por conexão."
        >
          <div className={classes.control}>
            <FormControl variant="outlined" size="small" fullWidth>
              <Select
                id="schedule-type"
                value={scheduleType}
                onChange={async (e) => {
                  handleScheduleType(e.target.value);
                }}
                SelectDisplayProps={{ "aria-label": i18n.t("settings.settings.options.officeScheduling") }}
              >
                <MenuItem value={"disabled"}>{i18n.t("settings.settings.options.disabled")}</MenuItem>
                <MenuItem value={"queue"}>{i18n.t("settings.settings.options.queueManagement")}</MenuItem>
                <MenuItem value={"company"}>{i18n.t("settings.settings.options.companyManagement")}</MenuItem>
                <MenuItem value={"connection"}>{i18n.t("settings.settings.options.connectionManagement")}</MenuItem>
              </Select>
            </FormControl>
            <Updating classes={classes} show={loadingScheduleType} placement="updatingBelow" />
          </div>
        </SettingRow>

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.sendGreetingAccepted")}
          description="Envia uma saudação assim que o atendimento é aceito."
          value={SendGreetingAccepted}
          onChange={handleSendGreetingAccepted}
          loading={loadingSendGreetingAccepted}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.userRandom")}
          description="Distribui novos tickets entre os atendentes disponíveis."
          value={UserRandom}
          onChange={handleUserRandom}
          loading={loadingUserRandom}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.sendMsgTransfTicket")}
          description="Notifica o cliente quando o ticket muda de setor ou atendente."
          value={SettingsTransfTicket}
          onChange={handleSettingsTransfTicket}
          loading={loadingSettingsTransfTicket}
        />

        {/* TIPO DO BOT */}
        <SettingRow
          wide
          label={i18n.t("settings.settings.options.chatBotType")}
          description="Formato do menu enviado pelo chatbot das filas."
        >
          <div className={classes.control}>
            <FormControl variant="outlined" size="small" fullWidth>
              <Select
                id="chatBotType"
                value={chatBotType}
                onChange={async (e) => {
                  handleChatBotType(e.target.value);
                }}
                SelectDisplayProps={{ "aria-label": i18n.t("settings.settings.options.chatBotType") }}
              >
                <MenuItem value={"text"}>Texto</MenuItem>
              </Select>
            </FormControl>
            <Updating classes={classes} show={loadingScheduleType} placement="updatingBelow" />
          </div>
        </SettingRow>

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.acceptCallWhatsapp")}
          description="Exibe o aviso configurado quando uma ligação não é aceita."
          value={AcceptCallWhatsapp}
          onChange={handleAcceptCallWhatsapp}
          loading={loadingAcceptCallWhatsapp}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.sendSignMessage")}
          description="Permite ao atendente decidir quando incluir a assinatura."
          value={sendSignMessage}
          onChange={handleSendSignMessage}
          loading={loadingSendSignMessage}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.sendGreetingMessageOneQueues")}
          description="Envia a saudação mesmo quando há somente uma fila disponível."
          value={sendGreetingMessageOneQueues}
          onChange={handleSendGreetingMessageOneQueues}
          loading={loadingSendGreetingMessageOneQueues}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.sendQueuePosition")}
          description="Informa automaticamente a posição atual do contato na fila."
          value={sendQueuePosition}
          onChange={handleSendQueuePosition}
          loading={loadingSendQueuePosition}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.sendFarewellWaitingTicket")}
          description="Envia uma mensagem de despedida ao finalizar um ticket em espera."
          value={sendFarewellWaitingTicket}
          onChange={handleSendFarewellWaitingTicket}
          loading={loadingSendFarewellWaitingTicket}
        />

        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.acceptAudioMessageContact")}
          description="Autoriza o recebimento de áudio enviado por qualquer contato."
          value={acceptAudioMessageContact}
          onChange={handleAcceptAudioMessageContact}
          loading={loadingAcceptAudioMessageContact}
        />
      </SettingsSection>

      <SettingsSection id="tickets" title="Regras de tickets" description="Encerramento, alertas e carteira de clientes." icon={<TuneOutlined />} query={search} defaultOpen={false}>
        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.requiredTag")}
          description="Exige uma tag antes de concluir o ticket."
          value={requiredTag}
          onChange={handleRequiredTag}
          loading={loadingRequiredTag}
        />
        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.closeTicketOnTransfer")}
          description="Encerra o ticket atual quando ele for movido para outra fila."
          value={closeTicketOnTransfer}
          onChange={handleCloseTicketOnTransfer}
          loading={loadingCloseTicketOnTransfer}
          enabledValue={true}
          disabledValue={false}
        />
        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.showNotificationPending")}
          description="Mostra alertas de tickets que continuam pendentes."
          value={showNotificationPending}
          onChange={handleShowNotificationPending}
          loading={loadingShowNotificationPending}
          enabledValue={true}
          disabledValue={false}
        />
        <ToggleSetting
          classes={classes}
          label={i18n.t("settings.settings.options.DirectTicketsToWallets")}
          description="Direciona automaticamente clientes para a carteira definida."
          value={directTicketsToWallets}
          onChange={handleDirectTicketsToWallets}
          loading={loadingDirectTicketsToWallets}
          enabledValue={true}
          disabledValue={false}
        />
      </SettingsSection>

      <SettingsSection id="messages" title="Mensagens automáticas" description="Personalize saudações e avisos enviados durante o atendimento." icon={<ChatBubbleOutline />} query={search} defaultOpen={false}>
        <div className={clsx(p.grid2, p.labelsAbove, classes.fields)}>
          <div className={classes.field}>
            <TextField
              id="transferMessage"
              name="transferMessage"
              size="small"
              fullWidth
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.transferMessage")}
              variant="outlined"
              value={transferMessage}
              required={SettingsTransfTicket === "enabled"}
              onChange={async (e) => {
                handletransferMessage(e.target.value);
              }}
            />
            <Updating classes={classes} show={loadingTransferMessage} placement="updatingCorner" />
          </div>

          <div className={classes.field}>
            <TextField
              id="greetingAcceptedMessage"
              name="greetingAcceptedMessage"
              size="small"
              fullWidth
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.greetingAcceptedMessage")}
              variant="outlined"
              value={greetingAcceptedMessage}
              required={SendGreetingAccepted === "enabled"}
              onChange={async (e) => {
                handleGreetingAcceptedMessage(e.target.value);
              }}
            />
            <Updating classes={classes} show={loadingGreetingAcceptedMessage} placement="updatingCorner" />
          </div>

          <div className={classes.field}>
            <TextField
              id="AcceptCallWhatsappMessage"
              name="AcceptCallWhatsappMessage"
              size="small"
              fullWidth
              multiline
              rows={3}
              label={i18n.t("settings.settings.customMessages.AcceptCallWhatsappMessage")}
              variant="outlined"
              required={AcceptCallWhatsapp === "disabled"}
              value={AcceptCallWhatsappMessage}
              onChange={async (e) => {
                handleAcceptCallWhatsappMessage(e.target.value);
              }}
            />
            <Updating classes={classes} show={loadingAcceptCallWhatsappMessage} placement="updatingCorner" />
          </div>

          <div className={classes.field}>
            <TextField
              id="sendQueuePositionMessage"
              name="sendQueuePositionMessage"
              size="small"
              fullWidth
              multiline
              required={sendQueuePosition === "enabled"}
              rows={3}
              label={i18n.t("settings.settings.customMessages.sendQueuePositionMessage")}
              variant="outlined"
              value={sendQueuePositionMessage}
              onChange={async (e) => {
                handlesendQueuePositionMessage(e.target.value);
              }}
            />
            <Updating classes={classes} show={loadingSendQueuePositionMessage} placement="updatingCorner" />
          </div>
        </div>
      </SettingsSection>

      <SettingsSection id="privacy" title="Privacidade e consentimento" description="Controles de proteção dos dados dos contatos." icon={<SecurityOutlined />} query={search} defaultOpen={false}>
        <div>
          <ToggleSetting
            classes={classes}
            label={i18n.t("settings.settings.options.enableLGPD")}
            description="Ativa os controles de consentimento e proteção de dados."
            value={enableLGPD}
            onChange={handleEnableLGPD}
            loading={loadingEnableLGPD}
          />
          {/*-----------------LGPD-----------------*/}
          {enableLGPD === "enabled" && (
            <ToggleSetting
              classes={classes}
              label={i18n.t("settings.settings.LGPD.obfuscateMessageDelete")}
              description="Protege o conteúdo de mensagens removidas pelo contato."
              value={lgpdDeleteMessage}
              onChange={handleLGPDDeleteMessage}
              loading={loadingLGPDDeleteMessage}
            />
          )}
          {enableLGPD === "enabled" && (
            <ToggleSetting
              classes={classes}
              label={i18n.t("settings.settings.LGPD.alwaysConsent")}
              description="Solicita novamente o consentimento de uso dos dados."
              value={lgpdConsent}
              onChange={handleLGPDConsent}
              loading={loadingLGPDConsent}
            />
          )}
          {enableLGPD === "enabled" && (
            <ToggleSetting
              classes={classes}
              label={i18n.t("settings.settings.LGPD.obfuscatePhoneUser")}
              description="Oculta o número do contato para perfis de usuário."
              value={lgpdHideNumber}
              onChange={handleLGPDHideNumber}
              loading={loadingLGPDHideNumber}
            />
          )}
        </div>
        {enableLGPD === "enabled" && (
          <div className={clsx(p.stack, p.labelsAbove, classes.fields, classes.fieldsAfterList)}>
            <div className={classes.field}>
              <TextField
                id="lgpdMessage"
                name="lgpdMessage"
                size="small"
                fullWidth
                multiline
                rows={3}
                label={i18n.t("settings.settings.LGPD.welcome")}
                variant="outlined"
                value={lgpdMessage}
                onChange={async (e) => {
                  handleLGPDMessage(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadinglgpdMessage} placement="updatingCorner" />
            </div>
            <div className={classes.field}>
              <TextField
                id="lgpdLink"
                name="lgpdLink"
                size="small"
                fullWidth
                label={i18n.t("settings.settings.LGPD.linkLGPD")}
                variant="outlined"
                value={lgpdLink}
                onChange={async (e) => {
                  handleLGPDLink(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingLGPDLink} placement="updatingCorner" />
            </div>
          </div>
        )}
      </SettingsSection>

      <SettingsSection id="contacts" title="Identificação de contatos" description="Defina o prefixo usado ao copiar dados de um contato." icon={<ContactMailOutlined />} query={search} defaultOpen={false}>
        {/* CONFIGURAÇÃO SIGLA PARA CÓPIA DE CONTATOS */}
        <SettingRow wide label={i18n.t("settings.settings.options.copyContactPrefix")}>
          <div className={classes.control}>
            <TextField
              id="copyContactPrefix"
              name="copyContactPrefix"
              size="small"
              fullWidth
              variant="outlined"
              value={copyContactPrefix}
              placeholder={i18n.t("settings.settings.options.copyContactPrefixPlaceholder")}
              onChange={async (e) => {
                handleCopyContactPrefix(e.target.value);
              }}
              inputProps={{ "aria-label": i18n.t("settings.settings.options.copyContactPrefix") }}
            />
            <Updating classes={classes} show={loadingCopyContactPrefix} placement="updatingBelow" />
          </div>
        </SettingRow>
      </SettingsSection>

      <SettingsSection id="copilot" title="Assistente de inteligência artificial" description="Configuração do copiloto e acompanhamento do consumo." icon={<MemoryOutlined />} query={search} defaultOpen={false}>
        {/* COPILOTO (IA) */}
        <div>
          <SettingRow
            label={i18n.t("copilot.settings.enabled")}
            description={i18n.t("copilot.settings.enabledHelper")}
            className={classes.toggleRow}
          >
            <Updating classes={classes} show={loadingCopilotEnabled} />
            <Switch
              color="primary"
              checked={copilotEnabled === "enabled"}
              disabled={loadingCopilotEnabled}
              onChange={(e) => handleChangeCopilotEnabled(e.target.checked)}
              name="copilotEnabled"
              inputProps={{ "aria-label": i18n.t("copilot.settings.enabled") }}
            />
          </SettingRow>

          <SettingRow
            wide
            label={i18n.t("copilot.settings.apiKey")}
            description={copilotHasKey ? i18n.t("copilot.settings.apiKeyConfigured") : i18n.t("copilot.settings.apiKeyHelper")}
          >
            <div className={classes.control}>
              <TextField
                id="copilotApiKey"
                name="copilotApiKey"
                type="password"
                autoComplete="new-password"
                size="small"
                fullWidth
                variant="outlined"
                placeholder={copilotHasKey ? "***" : "sk-..."}
                value={copilotApiKey}
                onChange={(e) => setCopilotApiKey(e.target.value)}
                onBlur={handleSaveCopilotApiKey}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.target.blur();
                }}
                inputProps={{ "aria-label": i18n.t("copilot.settings.apiKey") }}
              />
              <Updating classes={classes} show={loadingCopilotApiKey} placement="updatingBelow" />
            </div>
          </SettingRow>

          <SettingRow
            wide
            label={i18n.t("copilot.settings.model")}
            description={i18n.t("copilot.settings.modelHelper")}
          >
            <div className={classes.control}>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select
                  id="copilotModel"
                  value={copilotModel}
                  onChange={(e) => handleChangeCopilotModel(e.target.value)}
                  SelectDisplayProps={{ "aria-label": i18n.t("copilot.settings.model") }}
                >
                  <MenuItem value="gpt-4o-mini">gpt-4o-mini</MenuItem>
                  <MenuItem value="gpt-4o">gpt-4o</MenuItem>
                  <MenuItem value="gpt-4.1-mini">gpt-4.1-mini</MenuItem>
                </Select>
              </FormControl>
              <Updating classes={classes} show={loadingCopilotModel} placement="updatingBelow" />
            </div>
          </SettingRow>

          <SettingRow
            label={i18n.t("copilot.settings.summarizeOnTransfer")}
            description={i18n.t("copilot.settings.summarizeOnTransferHelper")}
            className={classes.toggleRow}
          >
            <Updating classes={classes} show={loadingCopilotSummarizeOnTransfer} />
            <Switch
              color="primary"
              checked={copilotSummarizeOnTransfer === "enabled"}
              disabled={loadingCopilotSummarizeOnTransfer || copilotEnabled !== "enabled"}
              onChange={(e) => handleChangeCopilotSummarizeOnTransfer(e.target.checked)}
              name="copilotSummarizeOnTransfer"
              inputProps={{ "aria-label": i18n.t("copilot.settings.summarizeOnTransfer") }}
            />
          </SettingRow>
        </div>

        {/* Uso de IA (medição por empresa) — só admin */}
        {user && user.profile === "admin" && (
          <div className={classes.extra}>
            <AiUsageCard />
          </div>
        )}
      </SettingsSection>

      {isSuper() && (
        <SettingsSection id="billing" title="Integrações de pagamento" description="Credenciais dos provedores de cobrança da plataforma." icon={<PaymentOutlined />} query={search} defaultOpen={false}>
          <div className={clsx(p.grid2, p.labelsAbove, classes.fields)}>
            <div className={classes.field}>
              <TextField
                id="eficlientid"
                name="eficlientid"
                size="small"
                fullWidth
                label="Pix Efí — Client ID"
                variant="outlined"
                value={eficlientidType}
                onChange={async (e) => {
                  handleChangeEfiClientid(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingEfiClientidType} placement="updatingCorner" text="Atualizando..." />
            </div>
            <div className={classes.field}>
              <TextField
                id="eficlientsecret"
                type="password"
                autoComplete="off"
                name="eficlientsecret"
                size="small"
                fullWidth
                label="Pix Efí — Client Secret"
                variant="outlined"
                value={eficlientsecretType}
                onChange={async (e) => {
                  handleChangeEfiClientsecret(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingEfiClientsecretType} placement="updatingCorner" text="Atualizando..." />
            </div>
            <div className={classes.field}>
              <TextField
                id="efichavepix"
                name="efichavepix"
                size="small"
                fullWidth
                label="Pix Efí — Chave PIX"
                variant="outlined"
                value={efichavepixType}
                onChange={async (e) => {
                  handleChangeEfiChavepix(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingEfiChavepixType} placement="updatingCorner" text="Atualizando..." />
            </div>
            <div className={classes.field}>
              <TextField
                id="mpaccesstoken"
                type="password"
                autoComplete="off"
                name="mpaccesstoken"
                size="small"
                fullWidth
                label="Mercado Pago — Access Token"
                variant="outlined"
                value={mpaccesstokenType}
                onChange={async (e) => {
                  handleChangempaccesstoken(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingmpaccesstokenType} placement="updatingCorner" text="Atualizando..." />
            </div>
            <div className={classes.field}>
              <TextField
                id="stripeprivatekey"
                type="password"
                autoComplete="off"
                name="stripeprivatekey"
                size="small"
                fullWidth
                label="Stripe — Chave privada"
                variant="outlined"
                value={stripeprivatekeyType}
                onChange={async (e) => {
                  handleChangestripeprivatekey(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingstripeprivatekeyType} placement="updatingCorner" text="Atualizando..." />
            </div>
            <div className={classes.field}>
              <TextField
                id="asaastoken"
                type="password"
                autoComplete="off"
                name="asaastoken"
                size="small"
                fullWidth
                label="Token Asaas"
                variant="outlined"
                value={asaastokenType}
                onChange={async (e) => {
                  handleChangeasaastoken(e.target.value);
                }}
              />
              <Updating classes={classes} show={loadingasaastokenType} placement="updatingCorner" text="Atualizando..." />
            </div>
          </div>
        </SettingsSection>
      )}
    </div>
  );
}
